<template>
  <el-dialog custom-class="list-dialog" title="商品库存" :visible.sync="dialogFormVisible" center
             :close-on-click-modal="false"
             :append-to-body="true">
    <el-col :span="24">
      <div>
        <div class="search-content">
          <el-col :span="24" class="toobar">
            <el-col :span="24">
            <el-col :span="8">
              <el-input placeholder="输入商品名称" v-model="search.seedname" size="mini" clearable style="width: 120px"></el-input>
              <el-input placeholder="输入型号" v-model="search.model" size="mini" clearable style="width: 120px"></el-input>
              <el-input placeholder="输入规格" v-model="search.color" size="mini" clearable style="width: 120px"></el-input>
            </el-col>
            <el-col :span="8">&nbsp;
              <el-button type="primary" icon="el-icon-search" @click="bindGrid" size="mini">搜索</el-button>
              <el-button icon="el-icon-download" v-on:click="excelPort" size="mini">导出</el-button>
            </el-col>
            </el-col>
            <el-col :span="3" style="text-align: center" v-if="jxcstoreData.length>1">
              <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
            </el-col>
            <el-col :span="20" v-if="jxcstoreData.length>1">
              <el-checkbox-group v-model="checkedCangkus" @change="handleCheckedCitiesChange">
                <el-checkbox v-for="item in jxcstoreData" :label="item.cangkucode" :key="item.cangkucode">{{item.cangkuname}}</el-checkbox>
              </el-checkbox-group>
            </el-col>
          </el-col>
        </div>
        <el-table
          :data="tableData.filter(data =>
          (!search.seedname || data.seedname.toLowerCase().includes(search.seedname.toLowerCase()))&&
          (!search.model||data.model.toLowerCase().includes(search.model.toLowerCase()))&&
          (!search.color||data.color.toLowerCase().includes(search.color.toLowerCase()))
          )"
          :height="eltableheight"
          size="mini"
          :summary-method="getSummaries"
          show-summary
          border
          style="width: 100%;">
          <el-table-column
            width="60"
            label="序号"
            align="center">
            <template slot-scope="scope">
              {{1+scope.$index}}
            </template>
          </el-table-column>
          <el-table-column v-for="item in column" :key="item.value" :label="item.name" :show-overflow-tooltip="true"
                           :align="item.align" header-align="center"
                           :width="item.width" :prop="item.value">
            <template slot-scope="scope">
              <div v-if="item.align=='left'">{{ scope.row[item.value] }}</div>
              <div v-else>{{ scope.row[item.value]== 0 ? "":scope.row[item.value] }}</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" header-align="center" align="left" width="120">
            <template slot-scope="scope">
              <el-button size="mini"   @click="handleEdit(scope.$index, scope.row)">查看
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-col>
    <StorageFrameView ref="DataContactView"></StorageFrameView>
    <AllocationEditNew ref="DataContactEdit2" @bindGrid="bindGrid"></AllocationEditNew>
  </el-dialog>
</template>
<script>

  import {getGoodsTree} from '@/api/set/jxcgooddetail';
  import {getFramelistwithstore} from '@/api/set/jxcresultstore';
  import StorageFrameView from './StorageFrameView';
  import AllocationEditNew from '@/components/warehouse/AllocationEditNew';

  export default {
    name: 'StorageFrameDetail',
    data() {
      let yearnow = new Date().getFullYear()
      let monthnow = new Date().getMonth() + 1
      return {
        afterSearch: false,
        userInfoModel: {},
        msg: 'Welcome to Your Vue.js App',
        addVisible: false,
        dialogFormVisible: false,
        eltableheight: 300,
        searchdata: "",
        search:{categoryname:'',seedname:'',model:'',color:''},
        showCat:false,
        checkedCangkus:[],
        cangkucode: "",
        jxcstoreData: [],
        minyear: yearnow,
        minmonth: monthnow,
        maxyear: yearnow,
        maxmonth: monthnow,
        yearflag: '',
        loading: true,
        status: "",
        seedcode: "",
        seedname: "",
        iscsshow: '',
        year: '',
        guids: "",
        isdeliverShow: true,
        isIndeterminate:false,
        checkAll:false,
        allOptions:[],
        gu: "",
        allowTransfer: false,//允许调拨
        column:[],
        pagination: {
          currentPage: 1,
          pageSize: 0,
          total: 0,
        },
        tableData: [],
        timer:null,
        oldtableData: [],//备份tableData
      }
    },
    props: {
    },
    methods: {
      handleCheckAllChange(val) {
        this.checkedCangkus = val ? this.allOptions : [];
        this.isIndeterminate = false;
      },
      handleCheckedCitiesChange(value) {
        let checkedCount = value.length;
        this.checkAll = checkedCount === this.jxcstoreData.length;
        this.isIndeterminate = checkedCount > 0 && checkedCount < this.jxcstoreData.length;
      },
      //导出excel
      excelPort() {
        let header1 = []
        let column1 = [];
        for (let i in this.column) {
          header1.push(this.column[i].name);
          column1.push(this.column[i].value);
        }
        var name = new Date();
        name = "库存" + this.fmtDate(name);
        this.$exportExcel(header1, column1, this.tableData, name)
      },
      getCangkuName(cangkucode) {
        for (let i = 0; i < this.jxcstoreData.length; i++) {
          if (cangkucode == this.jxcstoreData[i].cangkucode) {
            return this.jxcstoreData[i].cangkuname;
            break
          }
        }
        return '';
      },
      //汇总
      getSummaries(param) {
        const {columns, data} = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '合计';
            return;
          }else if (index === 1) {
            sums[index] = '';
            return;
          }
            var values = [];
          data.map(function (item) {
            if (column.property != 'model' && column.property != 'color' && column.property != 'costprice')
              values.push(Number(item[column.property]));
          });
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
          } else {
            sums[index] = '';
          }
        });

        return sums;
      },
      //时间格式化
      fmtDate(obj) {
        var date = new Date(obj);
        var y = 1900 + date.getYear();
        var m = "0" + (date.getMonth() + 1);
        var d = "0" + date.getDate();
        return y + m.substring(m.length - 2, m.length) + d.substring(d.length - 2, d.length);
      },
      handleEdit(index, row) {//查看页面
        row.cangkucode=this.checkedCangkus[0];
        row.cangkuname=this.getCangkuName(row.cangkucode);
        row.categorycode=this.guids;
        this.$refs.DataContactView.initData(row, this.minyear, this.minmonth, this.minyear, this.minmonth);
      },
      handleTransfer(index, item) {//调拨页面
        this.$refs.DataContactEdit2.show()
        this.$refs.DataContactEdit2.initData(item)
      },
      initParam(param) {
        this.dialogFormVisible=true;
        this.allowTransfer = true;
        this.jxcstoreData = param.jxcstoreData;
        this.guids = param.guids;
        this.checkedCangkus = param.checkedCangkus;
        this.minyear = param.minyear;
        this.minmonth = param.minmonth;
        this.bindGrid();
      },
      bindGrid() {//绑定列表
        var cangkucodes = '';
        if (this.checkedCangkus.length == 0) {
          this.$message({
            message: '请先选择仓库！',
            type: 'error'
          })
          return;
        }
        this.afterSearch = true;
        this.tableData = []
        this.oldtableData = []
        for (let i in this.checkedCangkus) {
          cangkucodes += this.checkedCangkus[i] + ';';
        }
        this.column = [];
        getFramelistwithstore({
          searchdata: '',//产品名称（保留 暂不考虑）
          categorycode: this.guids,//产品分类（单选）
          cangkucode: cangkucodes,//选择的仓库（多选）
          seedcode: '',
          minyear: this.minyear,
          minmonth: this.minmonth,
          maxyear: this.minyear,
          maxmonth: this.minmonth,
          nostock: 1,
        }).then(response => {
          this.eltableheight = this.tableHeight(125);

          this.oldtableData = response.data.obj

          this.column.push({name: '商品编码', value: 'seedcode', width: '80px', align: 'left'})
          this.column.push({name: '商品名称', value: 'seedname', width: '150px', align: 'left'})
          this.column.push({name: '年份', value: 'goodyear', width: '60px', align: 'left'})
          this.column.push({name: '型号', value: 'model', width: '80px', align: 'left'})
          this.column.push({name: '规格', value: 'color', width: '80px', align: 'left'})
          // this.column.push({name: '零售价', value: 'costprice', width: '80px', align: 'right'})

          var moreCangku = this.checkedCangkus.length > 1;
          if (!moreCangku) {//只有一个仓库
            this.column.push({name: '期初', value: 'openbalnum', width: '100px', align: 'right'});
            this.column.push({name: '入库', value: 'debitnum', width: '100px', align: 'right'});
            this.column.push({name: '出库', value: 'creditnum', width: '100px', align: 'right'});
            this.column.push({
              name: this.getCangkuName(this.checkedCangkus[0]),
              value: this.checkedCangkus[0],
              width: '100px',
              align: 'right'
            });
            this.column.push({name: '待发货', value: 'deliverying', width: '100px', align: 'right'});
            this.column.push({name: '调拨中', value: 'transfernum', width: '100px', align: 'right'});
            this.column.push({name: '可用数', value: 'canuse', width: '100px', align: 'right'});
            this.column.push({name: '采购中', value: 'buynum', width: '100px', align: 'right'});
          } else {//有多个仓库
            for (let i in this.checkedCangkus) {
              this.column.push({
                name: this.getCangkuName(this.checkedCangkus[i]),
                value: this.checkedCangkus[i],
                width: '100px',
                align: 'right'
              });
            }
            this.column.push({name: '合计', value: 'sum', width: '100px', align: 'right'});
          }

          for (let i in this.oldtableData) {
            var row = this.oldtableData[i];
            if (row.packagesize == null)
              row.packagesize = '';
            row.model = '';
            row.color = '';
            if (row.packagesize) {
              var pg = JSON.parse(row.packagesize);
              row.model = pg.M;
              row.color = pg.C;
            }

            var sum = row.openbalnum + row.debitnum - row.creditnum;
            row[row.cangkucode] = sum;
            row.canuse=sum-row.deliverying+ row.transfernum;
            row.sum = sum;
            if (moreCangku) {//多仓库的时候需要合并
              var hasValue = false;
              for (let j in this.tableData) {
                if (this.tableData[j].seedcode == row.seedcode && this.tableData[j].packagesize == row.packagesize) {
                  hasValue = true;
                  this.tableData[j][row.cangkucode] = sum;
                  this.tableData[j].sum += sum;
                  break;
                }
              }
              if (!hasValue)
                this.tableData.push(row)
            } else {
              this.tableData.push(row)
            }
          }

          if (!this.showCat) {
            this.tableData.sort(function (a, b) {
              if (a.model == b.model)
                return a.color.localeCompare(b.color)
              else
                return a.model.localeCompare(b.model)
            })
          }
        }).catch((error) => {
          console.log(error)
        });
      },
    },
    mounted() {

    },
    components: {
      StorageFrameView,
      AllocationEditNew
    }
  }
</script>

<style>
  .el-table .warning-row {
    background: oldlace;
  }
</style>



// WEBPACK FOOTER //
// src/components/testorder/warehouse/StorageFrameDetail.vue